import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  BarChart3, 
  FileText, 
  FilePlus, 
  Users, 
  User
} from 'lucide-react';

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Check if a path is active
  const isActive = (path) => {
    if (path === '/dashboard' && location.pathname === '/dashboard') {
      return true;
    }
    return location.pathname.startsWith(path) && path !== '/dashboard';
  };

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 flex z-10">
      {/* Dashboard */}
      <Link 
        to="/dashboard" 
        className="py-2 flex flex-col items-center justify-center flex-1 text-xs"
      >
        <div className={`p-1 rounded-full ${isActive('/dashboard') ? 'text-primary-600' : 'text-gray-600'}`}>
          <BarChart3 className="h-6 w-6" />
        </div>
        <span className={isActive('/dashboard') ? 'text-primary-600 font-medium' : 'text-gray-600'}>Dashboard</span>
      </Link>
      
      {/* Reports - Create as dropdown trigger */}
      <Link 
        to="/dashboard/report-types" 
        className="py-2 flex flex-col items-center justify-center flex-1 text-xs"
      >
        <div 
          className={location.pathname.includes('/report-types') ? 'text-primary-600 font-medium' : 'text-gray-600'}
        >
          <FileText className="h-6 w-6" />
        </div>
        <span 
          className={location.pathname.includes('/report-types') ? 'text-primary-600 font-medium' : 'text-gray-600'}
        >Reports</span>
      </Link>
      
      {/* Create button */}
      <div className="py-2 flex flex-col items-center justify-center flex-1">
        <button 
          onClick={() => navigate('/dashboard/expense-reports/new')} 
          className="h-12 w-12 bg-primary-600 rounded-full flex items-center justify-center text-white shadow-lg transform -translate-y-2"
        >
          <FilePlus className="h-6 w-6" />
        </button>
        <span className="text-xs mt-1">Create</span>
      </div>
      
      {/* Collaborators */}
      <Link 
        to="/dashboard/invitations" 
        className="py-2 flex flex-col items-center justify-center flex-1 text-xs"
      >
        <div className={`p-1 rounded-full ${isActive('/dashboard/invitations') ? 'text-primary-600' : 'text-gray-600'}`}>
          <Users className="h-6 w-6" />
        </div>
        <span className={isActive('/dashboard/invitations') ? 'text-primary-600 font-medium' : 'text-gray-600'}>Team</span>
      </Link>
      
      {/* Profile */}
      <Link 
        to="/dashboard/profile-page" 
        className="py-2 flex flex-col items-center justify-center flex-1 text-xs"
      >
        <div className={`p-1 rounded-full ${isActive('/dashboard/profile-page') ? 'text-primary-600' : 'text-gray-600'}`}>
          <User className="h-6 w-6" />
        </div>
        <span className={isActive('/dashboard/profile-page') ? 'text-primary-600 font-medium' : 'text-gray-600'}>Profile</span>
      </Link>
    </nav>
  );
};

export default MobileBottomNav;